import { AnalyticsEvent } from "../models";

export class ChipotleUVerificationLinkClickEvent implements AnalyticsEvent {
    name = "ChipotleUVerificationLinkClickEvent";
    constructor() {}
}
